import { useOuterClick } from 'providers/OutsideClick';

function WrapperPopUp(props) {
  const myRef = useOuterClick((e) => {
    if (e.srcElement.className === 'modal_background') {
      if(props.handleClear){
        props.handleClear()
      }
      if (props.formik !== undefined) {
        props.formik.resetForm();
      }
      props?.setModal(false);
    }
  });

  return (
    <div
      ref={myRef}
      style={props?.style}
      className={`custom_wrapper ${props?.className}`}
    >
      {props?.children}
    </div>
  );
}

export default WrapperPopUp;
